import { WifiOff, Wifi } from 'lucide-react';
import { AnimatePresence, motion } from 'motion/react';
import { useNetworkStatus } from '../lib/useNetworkStatus';
import { useApp } from '../context';

export default function NetworkStatusBar() {
  const { isOnline, wasOffline } = useNetworkStatus();
  const { state } = useApp();

  const showOffline = !isOnline;
  const showBackOnline = isOnline && wasOffline;
  const syncing = isOnline && state.offlineQueueLength > 0;

  const visible = showOffline || showBackOnline || syncing;

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: 'auto', opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.2 }}
          className="overflow-hidden z-40"
        >
          {showOffline ? (
            <div className="flex items-center justify-center gap-2 bg-amber-50 text-amber-800 py-2 px-5 text-sm font-medium">
              <WifiOff size={14} />
              <span>You're offline — changes will sync on reconnect</span>
            </div>
          ) : syncing ? (
            <div className="flex items-center justify-center gap-2 bg-blue-50 text-blue-700 py-2 px-5 text-sm font-medium">
              <Wifi size={14} className="animate-pulse" />
              <span>
                Syncing {state.offlineQueueLength} change{state.offlineQueueLength !== 1 ? 's' : ''}
                ...
              </span>
            </div>
          ) : showBackOnline ? (
            <div className="flex items-center justify-center gap-2 bg-green-50 text-green-700 py-2 px-5 text-sm font-medium">
              <Wifi size={14} />
              <span>Back online!</span>
            </div>
          ) : null}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
